import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, useToken } from "../../contexts/AuthContext";
import { CoyResource } from "../../Resources";
import { ShowAlert } from "../utils/alerts";
import { ShowImage } from "../utils/image";

const SignIn = () => {
    document.title = "Login";
    const [inputs, setInputs] = useState({});
    const [errors, setErrors] = useState();
    const [coy, setCoy] = useState({})
    let auth = useAuth();
    let token = useToken();
    let navigate = useNavigate();

    useEffect(() => {
        if (token === "null" || token === "undefined" || token === null) return;
        navigate("/", { replace: true });
    }, [auth, token, navigate]);
    useEffect(() => {
        CoyResource.info((r) => {
            if (!r) return setErrors({ error: "connection error" })
            if (r.status) return setCoy(r.body);
            if (!r.status) return setErrors(r.body);
        })
    }, []);

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setInputs(values => ({ ...values, [name]: value }));
    }
    const onFormSubmit = e => {
        e.preventDefault();
        setErrors(null);
        auth.signin(inputs, (resp) => {
            if (resp?.status) {
                navigate("/", { replace: true });
            } else {
                setErrors(resp?.body);
            }
        });
    }

    return (
        <div className="container" style={{ height: "100vh" }}>
            <div className="row justify-content-center align-items-center h-100">
                <div className="col-12 col-sm-9 col-md-6 col-lg-5 col-xl-4">
                    <div className="card shadow-lg o-hidden border-0 my-5">
                        <div className="card-body p-0">
                            <div className="row">
                                <div className="col-12">
                                    <ShowImage className="float-start" src={coy.photo} style={{ width: "100px" }} alt="logo" />
                                    <div className="p-5">
                                        <div className="text-center">
                                            <h4 className="text-dark mb-4">{coy.name}</h4>
                                        </div>
                                        <form onSubmit={onFormSubmit} className="user">
                                            <ShowAlert alerts={errors} tag="error" />
                                            <div className="mb-3">
                                                <input type="text" onChange={handleChange} className="form-control form-control-user" placeholder="Enter Username..." name="uname" />
                                                <ShowAlert alerts={errors} tag="uname_error" />
                                            </div>
                                            <div className="mb-3">
                                                <input type="password" onChange={handleChange} className="form-control form-control-user" placeholder="*******" name="pword" />
                                                <ShowAlert alerts={errors} tag="pword_error" />
                                            </div>
                                            <div className="mb-3">
                                                <div className="custom-control custom-checkbox small">
                                                    <div className="form-check">
                                                        <input type="checkbox" className="form-check-input custom-control-input" id="formCheck-1" />
                                                        <label className="form-check-label custom-control-label" htmlFor="formCheck-1">Remember Me</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <button className="btn btn-primary d-block btn-user w-100" type="submit">Login</button>
                                            <hr />
                                        </form>
                                        <div className="text-center"><a className="small" href="./">Forgot Password?</a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}
export default SignIn